import React, { useState } from "react";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthContext } from "./AuthProvider";
import UserSessionContext, { IUserSessionContext } from "../Services/Auth/UserSessionContext";
import { createPortal } from "react-dom";
import SessionExpirationModal from "./SessionExpirationModal";
import SessionTimeout from "./SessionTimeout";

export const AuthorizeRoute = ({ children }: { children: JSX.Element }) => {
    var auth = React.useContext(AuthContext); 

    const [showSessionExpirationWarning, setShowSessionExpirationWarning] = useState(false);
    const userSessionContext : IUserSessionContext = {
        showSessionExpirationWarning,
        setShowSessionExpirationWarning
    };

    if (auth.isAuthenticated()) {
        return <UserSessionContext.Provider value={userSessionContext}>
            <SessionTimeout/>
            {children}
            {showSessionExpirationWarning && createPortal(<SessionExpirationModal showModal={showSessionExpirationWarning} setShowSessionExpirationWarning={setShowSessionExpirationWarning} />, document.body)}
        </UserSessionContext.Provider>

    } else {
        auth.signinRedirect(null, window.location.pathname);
        return <AbpnSpinner/>;
    }

}